import React from 'react';
import { FileTextIcon, DownloadIcon } from 'lucide-react';
const newsletters2025 = [{
  title: 'The Manual - April 2025',
  href: '#',
  latest: true
}];
const newsletters2024 = [{
  title: 'The Manual - October 2024',
  href: '#'
}, {
  title: 'The Manual - September 2024',
  href: '#'
}, {
  title: 'The Manual - August 2024',
  href: '#'
}, {
  title: 'The Manual - July 2024',
  href: '#'
}, {
  title: 'The Manual - June 2024',
  href: '#'
}, {
  title: 'The Manual - May 2024',
  href: '#'
}, {
  title: 'The Manual - April 2024',
  href: '#'
}, {
  title: 'The Manual - January 2024',
  href: '#'
}];
const newsletters2023 = [{
  title: 'December 2023 Newsletter',
  href: '#'
}, {
  title: 'November 2023 Newsletter',
  href: '#'
}, {
  title: 'October 2023 Newsletter',
  href: '#'
}, {
  title: 'September 2023 Newsletter',
  href: '#'
}];
function NewsletterList({
  items
}: {
  items: {
    title: string;
    href: string;
    latest?: boolean;
  }[];
}) {
  return <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
    borderColor: '#ede9e0'
  }} data-id="element-2252">
      {items.map((nl, index) => <a key={nl.title} href={nl.href} className={`flex items-center gap-4 p-4 transition-colors hover:bg-gray-50 ${index < items.length - 1 ? 'border-b' : ''}`} style={{
      borderColor: '#ede9e0'
    }} data-id="element-2253">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
        backgroundColor: 'rgba(30,61,47,0.08)'
      }} data-id="element-2254">
            <FileTextIcon size={18} style={{
          color: '#1e3d2f'
        }} data-id="element-2255" />
          </div>
          <span className="text-base font-medium flex-1" style={{
        color: '#1e3d2f',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-2256">
            {nl.title}
          </span>
          {nl.latest && <span className="text-xs font-bold uppercase px-2 py-1 rounded" style={{
        backgroundColor: 'rgba(200,168,75,0.15)',
        color: '#c8a84b',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-2257">
              Latest
            </span>}
          <DownloadIcon size={16} className="flex-shrink-0" style={{
        color: '#999'
      }} data-id="element-2258" />
        </a>)}
    </div>;
}
export function NewsletterArchive() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2259">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2260">
        {/* Info Note */}
        <div className="flex items-start gap-3 p-4 rounded-xl mb-8" style={{
        backgroundColor: '#f0f7f3',
        border: '1px solid #1e3d2f'
      }} data-id="element-2261">
          <FileTextIcon size={20} className="flex-shrink-0 mt-0.5" style={{
          color: '#1e3d2f'
        }} data-id="element-2262" />
          <p className="text-sm font-medium" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2263">
            Click any link below to download a PDF version of that newsletter.
          </p>
        </div>

        {/* 2025 Archive */}
        <div className="mb-8" data-id="element-2264">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-5" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2265">
            2025
          </h2>
          <NewsletterList items={newsletters2025} data-id="element-2266" />
        </div>

        {/* 2024 Archive */}
        <div className="mb-8" data-id="element-2267">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-5" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2268">
            2024
          </h2>
          <NewsletterList items={newsletters2024} data-id="element-2269" />
        </div>

        {/* 2023 Archive */}
        <div data-id="element-2270">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-5" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2271">
            2023
          </h2>
          <NewsletterList items={newsletters2023} data-id="element-2272" />
        </div>
      </div>
    </div>;
}